import React from "react";
import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box/Box";
import useStyles from "./styles";
import Grid from "@material-ui/core/Grid/Grid";

export interface UserFilterCategoryProps {
  title: string;
  children: React.ReactNode;
}

export function UserFilterCategory(props: UserFilterCategoryProps) {
  const classes = useStyles();
  const { title, children } = props;
  return (
    <Grid item>
      <Box className={classes.filterCategory}>
        <Typography className={classes.title} variant="h4">
          { title }
        </Typography>
        <Grid className={classes.options} container>
          { children }
        </Grid>
      </Box>
    </Grid>
  );
}
